import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import WritingComponent from './components/exam/WritingComponent';
import ReadingComponent from './components/exam/ReadingComponent';
import ListeningComponent from './components/exam/ListeningComponent';
import StudentDashboard from './components/dashboard/StudentDashboard';
import SubmitResult from './components/exam/SubmitResult';
import AdminDashboard from "./components/dashboard/AdminDashboard";
import TableSelector from "./components/crud/TableSelector";
import TeacherDashboard from "./components/dashboard/TeacherDashboard";
import SubmissionStatisticDashboard from "./components/dashboard/SubmissionStatisticDashboard";
import CreateExamDashboard from "./components/dashboard/CreateExamDashboard";
import Sidebar from "./components/Sidebar";


const App = () => {
  const base_url = process.env.NODE_ENV === "production" 
    ? `https://${process.env.REACT_APP_VERCEL_URL}` : "http://localhost:6868";
  return (
    <Router>
      <div className="app-container flex">
        <div className="w-1/4">
          <Sidebar />
        </div>
        <div className="w-3/4">
          <Routes>
            <Route path="/" element={<StudentDashboard base_url={base_url} />} />
            <Route path="/student-dashboard" element={<StudentDashboard base_url={base_url}/>} />
            <Route path="/teacher-dashboard" element={<TeacherDashboard base_url={base_url}/>} />
            <Route path="/submission-statistic-dashboard" element={<SubmissionStatisticDashboard base_url={base_url}/>} />
            <Route path="/table-selector" element={<TableSelector base_url={base_url}/>} />
            <Route path="/admin-dashboard" element={<AdminDashboard base_url={base_url}/>} />
            <Route path="/create-exam-dashboard" element={<CreateExamDashboard base_url={base_url}/>} />
            <Route path="/reading/:id" element={<ReadingComponent />} />
            <Route path="/listening/:id" element={<ListeningComponent />} />
            <Route path="/writing/:id" element={<WritingComponent />} />
            <Route path="/submit-result" element={<SubmitResult />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
